import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["task", "onClick", "checkAndCompleteTask", "children"];
import Routes from 'ContentUtils/Routes';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { enableLinkedTour } from 'onboarding-tours/util/linkedTourUtils';
import { useTaskLink } from 'setup-guide-components/hooks/hub';
import { useHasDraftSitePages } from '../../../hooks/useHasDraftSitePages';
import { jsx as _jsx } from "react/jsx-runtime";
export const TASK_KEY = 'explore-publish-site';
export const ExplorePublishSiteButton = _ref => {
  let {
      task,
      onClick = () => {},
      children
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    id,
    link: publishSitePageLink,
    openLinkInNewTab,
    handholdingEnabled,
    handholdingGroupKeyOverride,
    handholdingSource
  } = task;
  const hasDraftSitePages = useHasDraftSitePages();
  let link;
  let handleButtonClick;
  if (hasDraftSitePages) {
    // use default task link to content-management-ui
    link = publishSitePageLink;
    handleButtonClick = onClick;
  } else {
    // set task link to content-creator so users can create a site page
    link = Routes.create('site_page', 'site_page', {
      hasThemedContentCreatorAccess: true,
      useActiveThemeContentCreator: true,
      activeThemeContentCreatorParams: {
        pageName: encodeURIComponent(I18n.text('cms-onboarding-lib.checklist.explorePublishSiteButton.pageName')),
        referrer: 'userGuide',
        referrerUrl: window.location.href
      }
    });
    // set session storage so the editor picks up the appropriate tour once they're redirected from content-creator
    handleButtonClick = () => {
      const tourAlias = 'publish-and-edit-editor:/pages/[0-9]*/editor/[0-9]*';
      enableLinkedTour({
        tourId: tourAlias,
        prevTourLength: 1
      });
      onClick();
    };
  }
  const href = useTaskLink(link, id, handholdingEnabled, handholdingGroupKeyOverride, handholdingSource);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    external: openLinkInNewTab,
    href: href,
    onClick: handleButtonClick
  }, buttonProps, {
    children: children
  }));
};